
export const ENV = {
  baseUrl: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL,
  publicUrl: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_URL : process.env.REACT_APP_URL,
  // test:
  //   process.env.NODE_ENV === 'production'
  //     ? process.env.GOOGLE_CLIENT_ID
  //     : process.env.GOOGLE_CLIENT_ID
};
